import React from 'react';
import styled from 'styled-components';
import { RiAdminFill } from 'react-icons/ri';

// Style the wrapper
const StyledIconWrapper = styled.svg`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;

  svg {
    width: 100%;
    height: 100%;
    color: #ffffff;
  }
`;

// Type RiAdminFill as a proper React component
const TypedRiAdminFill = RiAdminFill as unknown as React.FC<{ size?: number | string }>;

const AdminIcon: React.FC = () => (
  <StyledIconWrapper viewBox="0 0 24 24">
    <TypedRiAdminFill size={24} />
  </StyledIconWrapper>
);

export default AdminIcon;